export default __webpack_public_path__ + "static/media/lib-8.ea72195b.webp";